/**
 * Configurations based on current environment (auto environment detection and matching)
 */
var EnvironmentsConfig = new function() {

    var self = this;
    var data = {};

    var HOSTS = {
        HARRI: 'harri.com',
        TEAM_SCHEDULE: 'team.live',
        TEAM_SCHEDULE_DEV: 'teamworkz.net',
        TEAM_SCHEDULE_STAGING: 'teamstaging.live',
        TEAM_SCHEDULE_UAT: 'teamuat.live',
        TEAM_SCHEDULE_BETA: 'teambeta.live',
        HARRI_DEV: 'harridev.com',
        INTERNAL_PROD: 'internal-bcf49936-acd4-4f79-be5a-fad8a01526db.harri.com',
        INTERNAL_TEMP_PROD: 'internal-temp-bcf49936-acd4-4f79-be5a-fad8a01526db.harri.com',
        HARRI_UAT: 'harriuat.com',
        HARRI_BETA: 'harribeta.com'
    };

    var currentEnvironment;

    // Environment constants
    self.PRODUCTION = 'PRODUCTION';
    self.INTERNAL_PROD = 'INTERNAL_PROD';
    self.DEV        = 'DEV';
    self.BETA       = 'BETA';
    self.DEMO       = 'DEMO';
    self.DEFAULT    = 'DEFAULT';
    self.STAGING    = 'STAGING';
    self.UAT        = 'UAT';

    // Hosts constants
    self.HARRI = 'harri';
    self.TEAM_SCHEDULE = 'teamcloud';
    self.HARRI_DEV = "harridev";
    self.HARRI_UAT = "harriuat";
    self.HARRI_BETA = "harribeta";

    data['APIServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/core/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/core/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/core/api/v1/',
        UAT             : 'https://gateway.harriuat.com/core/api/v1/',
        BETA            : 'https://gateway.harribeta.com/core/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/core/api/v1/'
    };

    data['tsCoreServers'] = {
        PRODUCTION      : 'https://gateway.team.live/core/api/v1/',
        INTERNAL_PROD   : 'https://gateway.team.live/core/api/v1/',
        STAGING         : 'https://gateway.teamstaging.live/core/api/v1/',
        UAT             : 'https://gateway.teamuat.live/core/api/v1/',
        BETA            : 'https://gateway.teambeta.live/core/api/v1/',
        DEFAULT         : 'https://gateway.teamworkz.net/core/api/v1/'
    };

    data['coreReaderAPIServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/core-reader/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/core-reader/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/core-reader/api/v1/',
        UAT             : 'https://gateway.harriuat.com/core-reader/api/v1/',
        BETA            : 'https://gateway.harribeta.com/core-reader/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/core-reader/api/v1/'
    };

    data['ReportingSettingsManagement'] = {
        PRODUCTION      : 'https://gateway.harri.com/reporting-settings-management/api/',
        INTERNAL_PROD   : 'https://gateway.harri.com/reporting-settings-management/api/',
        STAGING         : 'https://gateway.harristaging.com/reporting-settings-management/api/',
        UAT             : 'https://gateway.harriuat.com/reporting-settings-management/api/',
        BETA            : 'https://gateway.harribeta.com/reporting-settings-management/api/',
        DEFAULT         : 'https://gateway.harridev.com/reporting-settings-management/api/'
    };

    data['OnboardingServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/core/onboarding/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/core/onboarding/v1/',
        STAGING         : 'https://gateway.harristaging.com/core/onboarding/v1/',
        UAT             : 'https://gateway.harriuat.com/core/onboarding/v1/',
        BETA            : 'https://gateway.harribeta.com/core/onboarding/v1/',
        DEFAULT         : 'https://gateway.harridev.com/core/onboarding/v1/'
    };

    data['DocumentToHtmlConverterLambda'] = {
        PRODUCTION      : 'https://gateway.harri.com/document-to-html-converter/',
        INTERNAL_PROD   : 'https://gateway.harri.com/document-to-html-converter/',
        STAGING         : 'https://gateway.harristaging.com/document-to-html-converter/',
        UAT             : 'https://gateway.harriuat.com/document-to-html-converter/',
        BETA            : 'https://gateway.harribeta.com/document-to-html-converter/',
        DEFAULT         : 'https://gateway.harridev.com/document-to-html-converter/'
    };


    data['InterviewServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/interview/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/interview/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/interview/api/v1/',
        UAT             : 'https://gateway.harriuat.com/interview/api/v1/',
        BETA            : 'https://gateway.harribeta.com/interview/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/interview/api/v1/'
    };

    data['Payroll'] = {
        PRODUCTION      : 'https://gateway.harri.com/payroll/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/payroll/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/payroll/api/v1/',
        UAT             : 'https://gateway.harriuat.com/payroll/api/v1/',
        BETA            : 'https://gateway.harribeta.com/payroll/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/payroll/api/v1/'
    };

    data['JobDistributor'] = {
        PRODUCTION      : 'https://gateway.harri.com/dispatcher/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/dispatcher/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/dispatcher/api/v1/',
        UAT             : 'https://gateway.harriuat.com/dispatcher/api/v1/',
        BETA            : 'https://gateway.harribeta.com/dispatcher/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/dispatcher/api/v1/'
    };

    data['Subscription'] = {
        PRODUCTION      : 'https://gateway.harri.com/public-subscription/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/public-subscription/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/public-subscription/api/v1/',
        UAT             : 'https://gateway.harriuat.com/public-subscription/api/v1/',
        BETA            : 'https://gateway.harribeta.com/public-subscription/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/public-subscription/api/v1/'
    };

    data['TeamServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/team/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/team/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/team/api/v1/',
        UAT             : 'https://gateway.harriuat.com/team/api/v1/',
        BETA            : 'https://gateway.harribeta.com/team/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/team/api/v1/'
    };

    data['Attendance'] = {
        PRODUCTION      : 'https://gateway.harri.com/attendance/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/attendance/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/attendance/api/v1/',
        UAT             : 'https://gateway.harriuat.com/attendance/api/v1/',
        BETA            : 'https://gateway.harribeta.com/attendance/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/attendance/api/v1/'
    };

    data['InAppNotificationCenter'] = {
        PRODUCTION      : 'https://gateway.harri.com/in-app-notification-center/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/in-app-notification-center/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/in-app-notification-center/api/v1/',
        UAT             : 'https://gateway.harriuat.com/in-app-notification-center/api/v1/',
        BETA            : 'https://gateway.harribeta.com/in-app-notification-center/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/in-app-notification-center/api/v1/'
    };

    data['TeamScheduleServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/scheduling/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/scheduling/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/scheduling/api/v1/',
        UAT             : 'https://gateway.harriuat.com/scheduling/api/v1/',
        BETA            : 'https://gateway.harribeta.com/scheduling/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/scheduling/api/v1/'
    };

	data['TeamCommunicationServers'] = {
		PRODUCTION      : 'https://gateway.harri.com/communication/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/communication/api/v1/',
		STAGING         : 'https://gateway.harristaging.com/communication/api/v1/',
        UAT             : 'https://gateway.harriuat.com/communication/api/v1/',
        BETA            : 'https://gateway.harribeta.com/communication/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/communication/api/v1/'
	};

    data['TSTeamServers'] = {
        PRODUCTION      : 'https://gateway.team.live/team/api/v1/',
        INTERNAL_PROD   : 'https://gateway.team.live/team/api/v1/',
        STAGING         : 'https://gateway.teamstaging.live/team/api/v1/',
        UAT             : 'https://gateway.teamuat.live/team/api/v1/',
        BETA            : 'https://gateway.teambeta.live/team/api/v1/',
        DEFAULT         : 'https://gateway.teamworkz.net/team/api/v1/'
    };

    data['TSAttendance'] = {
        PRODUCTION      : 'https://gateway.team.live/attendance/api/v1/',
        INTERNAL_PROD   : 'https://gateway.team.live/attendance/api/v1/',
        STAGING         : 'https://gateway.teamstaging.live/attendance/api/v1/',
        UAT             : 'https://gateway.teamuat.live/attendance/api/v1/',
        BETA            : 'https://gateway.teambeta.live/attendance/api/v1/',
        DEFAULT         : 'https://gateway.teamworkz.net/attendance/api/v1/'
    };

    data['TSTeamScheduleServers'] = {
        PRODUCTION      : 'https://gateway.team.live/scheduling/api/v1/',
        INTERNAL_PROD   : 'https://gateway.team.live/scheduling/api/v1/',
        STAGING         : 'https://gateway.teamstaging.live/scheduling/api/v1/',
        UAT             : 'https://gateway.teamuat.live/scheduling/api/v1/',
        BETA            : 'https://gateway.teambeta.live/scheduling/api/v1/',
        DEFAULT         : 'https://gateway.teamworkz.net/scheduling/api/v1/'
    };

    data['TSTeamCommunicationServers'] = {
        PRODUCTION      : 'https://gateway.team.live/communication/api/v1/',
        INTERNAL_PROD   : 'https://gateway.team.live/communication/api/v1/',
        STAGING         : 'https://gateway.teamstaging.live/communication/api/v1/',
        UAT             : 'https://gateway.teamuat.live/communication/api/v1/',
        BETA            : 'https://gateway.teambeta.live/communication/api/v1/',
        DEFAULT         : 'https://gateway.teamworkz.net/communication/api/v1/'
    };

    data['EmployeeAudit'] = {
        PRODUCTION      : 'https://gateway.harri.com/employee-audit/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/employee-audit/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/employee-audit/api/v1/',
        UAT             : 'https://gateway.harriuat.com/employee-audit/api/v1/',
        BETA            : 'https://gateway.harribeta.com/employee-audit/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/employee-audit/api/v1/',
    };

    data['HReportingV1'] = {
        PRODUCTION      : 'https://gateway.harri.com/reporting-generator/',
        INTERNAL_PROD   : 'https://gateway.harri.com/reporting-generator/',
        STAGING         : 'https://gateway.harristaging.com/reporting-generator/',
        UAT             : 'https://gateway.harriuat.com/reporting-generator/',
        BETA            : 'https://gateway.harribeta.com/reporting-generator/',
        DEFAULT         : 'https://gateway.harridev.com/reporting-generator/',
    };

    data['ReportTagManagementV1'] = {
        PRODUCTION      : 'https://gateway.harri.com/reporting-tagging-management/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/reporting-tagging-management/v1/',
        STAGING         : 'https://gateway.harristaging.com/reporting-tagging-management/v1/',
        UAT             : 'https://gateway.harriuat.com/reporting-tagging-management/v1/',
        BETA            : 'https://gateway.harribeta.com/reporting-tagging-management/v1/',
        DEFAULT         : 'https://gateway.harridev.com/reporting-tagging-management/v1/'
    };

    data['ReportingManagementV1'] = {
        PRODUCTION      : 'https://gateway.harri.com/reporting-management/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/reporting-management/v1/',
        STAGING         : 'https://gateway.harristaging.com/reporting-management/v1/',
        UAT             : 'https://gateway.harriuat.com/reporting-management/v1/',
        BETA            : 'https://gateway.harribeta.com/reporting-management/v1/',
        DEFAULT         : 'https://gateway.harridev.com/reporting-management/v1/'
    };

    data['GoodMorningToolEngine'] = {
        PRODUCTION      : 'https://gateway.harri.com/good-morning-tool-engine/v1/',
        STAGING         : 'https://gateway.harristaging.com/good-morning-tool-engine/v1/',
        UAT             : 'https://gateway.harriuat.com/good-morning-tool-engine/v1/',
        BETA            : 'https://gateway.harribeta.com/good-morning-tool-engine/v1/',
        DEFAULT         : 'https://gateway.harridev.com/good-morning-tool-engine/v1/'
    };

    data['ReportingServersV1'] = {
        PRODUCTION      : 'https://gateway.harri.com/core/reporting/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/core/reporting/v1/',
        STAGING         : 'https://gateway.harristaging.com/core/reporting/v1/',
        UAT             : 'https://gateway.harriuat.com/core/reporting/v1/',
        BETA            : 'https://gateway.harribeta.com/core/reporting/v1/',
        DEFAULT         : 'https://gateway.harridev.com/core/reporting/v1/'
    };

    data['ReportingServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/reporting-generator/',
        INTERNAL_PROD   : 'https://gateway.harri.com/reporting-generator/',
        STAGING         : 'https://gateway.harristaging.com/reporting-generator/',
        UAT             : 'https://gateway.harriuat.com/reporting-generator/',
        BETA            : 'https://gateway.harribeta.com/reporting-generator/',
        DEFAULT         : 'https://gateway.harridev.com/reporting-generator/'
    };

    data['SatisfactionServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/reporting-generator/',
        INTERNAL_PROD   : 'https://gateway.harri.com/reporting-generator/',
        DEFAULT         : 'https://gateway.harridev.com/reporting-generator/'
    };

    data['ReportingTrackingServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/track',
        INTERNAL_PROD   : 'https://gateway.harri.com/track',
        STAGING         : 'https://gateway.harristaging.com/track',
        UAT             : 'https://gateway.harriuat.com/track',
        BETA            : 'https://gateway.harribeta.com/track',
        DEFAULT         : 'https://gateway.harridev.com/track'
    };

    data['ReportsServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/export/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/export/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/export/api/v1/',
        UAT             : 'https://gateway.harriuat.com/export/api/v1/',
        BETA            : 'https://gateway.harribeta.com/export/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/export/api/v1/'
    };

    data['StatisticsServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/team-live-statistics/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/team-live-statistics/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/team-live-statistics/api/v1/',
        UAT             : 'https://gateway.harriuat.com/team-live-statistics/api/v1/',
        BETA            : 'https://gateway.harribeta.com/team-live-statistics/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/team-live-statistics/api/v1/'
    };

    data['ScheduleBudgeting'] = {
        PRODUCTION      : 'https://gateway.harri.com/sales-budgeting/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/sales-budgeting/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/sales-budgeting/api/v1/',
        UAT             : 'https://gateway.harriuat.com/sales-budgeting/api/v1/',
        BETA            : 'https://gateway.harribeta.com/sales-budgeting/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/sales-budgeting/api/v1/'
    };

    data['WendysLabor'] = {
        PRODUCTION      : 'https://gateway.harri.com/wendys-labor-generator/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/wendys-labor-generator/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/wendys-labor-generator/api/v1/',
        UAT             : 'https://gateway.harriuat.com/wendys-labor-generator/api/v1/',
        BETA            : 'https://gateway.harribeta.com/wendys-labor-generator/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/wendys-labor-generator/api/v1/'
    };

    data['McDLabor'] = {
        PRODUCTION      : 'https://gateway.harri.com/mcdonalds-labor-generator/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/mcdonalds-labor-generator/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/mcdonalds-labor-generator/api/v1/',
        UAT             : 'https://gateway.harriuat.com/mcdonalds-labor-generator/api/v1/',
        BETA            : 'https://gateway.harribeta.com/mcdonalds-labor-generator/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/mcdonalds-labor-generator/api/v1/'
    };

    data['CarrolLabor'] = {
        PRODUCTION      : 'https://gateway.harri.com/carrol-labor-model/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/carrol-labor-model/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/carrol-labor-model/api/v1/',
        UAT             : 'https://gateway.harriuat.com/carrol-labor-model/api/v1/',
        BETA            : 'https://gateway.harribeta.com/carrol-labor-model/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/carrol-labor-model/api/v1/'
    };

    data['JibLabor'] = {
        PRODUCTION      : 'https://gateway.harri.com/jack-in-the-box-labor-model/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/jack-in-the-box-labor-model/api/v1/',
        UAT             : 'https://gateway.harriuat.com/jack-in-the-box-labor-model/api/v1/',
        BETA            : 'https://gateway.harribeta.com/jack-in-the-box-labor-model/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/jack-in-the-box-labor-model/api/v1/'
    };

    data['GastronomyLabor'] = {
        PRODUCTION      : 'https://gateway.harri.com/gastronomy-labor-model/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/gastronomy-labor-model/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/gastronomy-labor-model/api/v1/',
        UAT             : 'https://gateway.harriuat.com/gastronomy-labor-model/api/v1/',
        BETA            : 'https://gateway.harribeta.com/gastronomy-labor-model/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/gastronomy-labor-model/api/v1/'
    };

    data['OperatingHours'] = {
        PRODUCTION      : 'https://gateway.harri.com/brand-operating-hour-setting/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/brand-operating-hour-setting/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/brand-operating-hour-setting/api/v1/',
        UAT             : 'https://gateway.harriuat.com/brand-operating-hour-setting/api/v1/',
        BETA            : 'https://gateway.harribeta.com/brand-operating-hour-setting/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/brand-operating-hour-setting/api/v1/'
    };

    data['InteractionsServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/interactions/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/interactions/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/interactions/api/v1/',
        UAT             : 'https://gateway.harriuat.com/interactions/api/v1/',
        BETA            : 'https://gateway.harribeta.com/interactions/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/interactions/api/v1/'
    };

    data['MinorSchedulingServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/minor-scheduling/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/minor-scheduling/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/minor-scheduling/api/v1/',
        UAT             : 'https://gateway.harriuat.com/minor-scheduling/api/v1/',
        BETA            : 'https://gateway.harribeta.com/minor-scheduling/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/minor-scheduling/api/v1/'
    };

    data['OMISServer'] = {
        PRODUCTION      : 'https://omis.harri.com',
        INTERNAL_PROD   : 'https://omis.harri.com',
        DEV             : '//dev.omis.harri.com',
        DEFAULT         : '//dev.omis.harri.com'
    };

	data['MediaServer'] = {
		PRODUCTION      : 'https://media-cdn.harri.com/',
        INTERNAL_PROD   : 'https://media-cdn.harri.com/',
		STAGING         : 'https://media-cdn.harriuat.com/',
        UAT             : 'https://media-cdn.harriuat.com/',
        BETA            : 'https://media-cdn.harribeta.com/',
		DEMO            : '//media-cdn.harri.com/',
		DEFAULT         : '//media-cdn.harridev.com/'
	};

    data['TranscodedMediaServer'] = {
        PRODUCTION      : 'https://transcoded.harri.com/',
        INTERNAL_PROD   : 'https://transcoded.harri.com/',
        STAGING         : 'https://transcoded.harriuat.com/',
        UAT             : 'https://transcoded.harriuat.com/',
        BETA            : 'https://transcoded.harri.com/',
        DEMO            : '//transcoded.harridev.com/',
        DEFAULT         : '//transcoded.harridev.com/'
    };

	data['TeamMediaServer'] = {
		PRODUCTION      : 'https://team.harri.com/',
        INTERNAL_PROD   : 'https://team.harri.com/',
        STAGING         : 'http://team.harriuat.com/',
        UAT             : 'http://team.harriuat.com/',
        BETA            : 'https://team.harri.com/',
		DEMO            : '//team.harridev.com/',
		DEFAULT         : '//team.harridev.com/'
	};

	data['TeamCommunicationMediaServer'] = {
		PRODUCTION      : 'https://team-communication.harri.com/',
        INTERNAL_PROD   : 'https://team-communication.harri.com/',
		STAGING         : 'https://team-communication.harri.com/',
        UAT             : 'https://team-communication.harri.com/',
        BETA            : 'https://team-communication.harri.com/',
		DEMO            : '//team-communication.harridev.com/',
		DEFAULT         : '//team-communication.harridev.com/'
	};

    data['LPMServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/lpm-api/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/lpm-api/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/lpm-api/api/v1/',
        UAT             : 'https://gateway.harriuat.com/lpm-api/api/v1/',
        BETA            : 'https://gateway.harribeta.com/lpm-api/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/lpm-api/api/v1/'
    };

    data['DailyActivityServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/daily-activity-data/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/daily-activity-data/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/daily-activity-data/api/v1/',
        UAT             : 'https://gateway.harriuat.com/daily-activity-data/api/v1/',
        BETA            : 'https://gateway.harribeta.com/daily-activity-data/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/daily-activity-data/api/v1/'
    };

    data['LPMAggregatorServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/lpm-aggregator/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/lpm-aggregator/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/lpm-aggregator/api/v1/',
        UAT             : 'https://gateway.harriuat.com/lpm-aggregator/api/v1/',
        BETA            : 'https://gateway.harribeta.com/lpm-aggregator/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/lpm-aggregator/api/v1/'
    };

    data['CoreHrUserPayrollProfileServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/core-hr-user-payroll-profile/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/core-hr-user-payroll-profile/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/core-hr-user-payroll-profile/api/v1/',
        UAT             : 'https://gateway.harriuat.com/core-hr-user-payroll-profile/api/v1/',
        BETA            : 'https://gateway.harribeta.com/core-hr-user-payroll-profile/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/core-hr-user-payroll-profile/api/v1/'
    };

    data['CoreHrUpdatesIntegrationServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/core-hr-updates-integration/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/core-hr-updates-integration/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/core-hr-updates-integration/api/v1/',
        UAT             : 'https://gateway.harriuat.com/core-hr-updates-integration/api/v1/',
        BETA            : 'https://gateway.harribeta.com/core-hr-updates-integration/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/core-hr-updates-integration/api/v1/'
    };

    data['GatewayTeamLiveServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/teamlive/',
        INTERNAL_PROD   : 'https://gateway.harri.com/teamlive/',
        STAGING         : 'https://gateway.harristaging.com/teamlive/',
        UAT             : 'https://gateway.harriuat.com/teamlive/',
        BETA            : 'https://gateway.harribeta.com/teamlive/',
        DEFAULT         : 'https://gateway.harridev.com/teamlive/'
    };

    data['tsEmployeeBenefitsServer'] = {
        PRODUCTION      : 'https://gateway.team.live/employee-benefits/api/v1/',
        INTERNAL_PROD   : 'https://gateway.team.live/employee-benefits/api/v1/',
        STAGING         : 'https://gateway.teamstaging.live/employee-benefits/api/v1/',
        UAT             : 'https://gateway.teamuat.live/employee-benefits/api/v1/',
        BETA            : 'https://gateway.teambeta.live/employee-benefits/api/v1/',
        DEFAULT         : 'https://gateway.teamworkz.net/employee-benefits/api/v1/'
    };

    data['EmployeeBenefitsServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/employee-benefits/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/employee-benefits/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/employee-benefits/api/v1/',
        UAT             : 'https://gateway.harriuat.com/employee-benefits/api/v1/',
        BETA            : 'https://gateway.harribeta.com/employee-benefits/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/employee-benefits/api/v1/'
    };

    data['tsGatewayTeamLiveServer'] = {
        PRODUCTION      : 'https://gateway.team.live/teamlive/',
        INTERNAL_PROD   : 'https://gateway.team.live/teamlive/',
        STAGING         : 'https://gateway.teamstaging.live/teamlive/',
        UAT             : 'https://gateway.teamuat.live/teamlive/',
        BETA            : 'https://gateway.teambeta.live/teamlive/',
        DEFAULT         : 'https://gateway.teamworkz.net/teamlive/'
    };

    data['GatewayServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/',
        INTERNAL_PROD   : 'https://gateway.harri.com/',
        STAGING         : 'https://gateway.harristaging.com/',
        UAT             : 'https://gateway.harriuat.com/',
        BETA            : 'https://gateway.harribeta.com/',
        DEFAULT         : 'https://gateway.harridev.com/'
    };

    data['CommunityServer'] = {
        PRODUCTION      : 'https://sso-us-west-2.api.insided.com/auth/token/return',
        DEFAULT         : 'https://sso-us-west-2.api.insided.com/auth/token/return'
    };

    data['ZendeskServer'] = {
        PRODUCTION      : 'https://harrisupport.zendesk.com/',
        DEFAULT         : 'https://harrisupport1674837904.zendesk.com/'
    };

    data['GatewayWeatherServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/weather/api/v2/',
        INTERNAL_PROD   : 'https://gateway.harri.com/weather/api/v2/',
        STAGING         : 'https://gateway.harristaging.com/weather/api/v2/',
        UAT             : 'https://gateway.harriuat.com/weather/api/v2/',
        BETA            : 'https://gateway.harribeta.com/weather/api/v2/',
        DEFAULT         : 'https://gateway.harridev.com/weather/api/v2/'
    };

    data['TSLPMAggregatorServer'] = {
        PRODUCTION      : 'https://gateway.team.live/lpm-aggregator/api/v1/',
        INTERNAL_PROD   : 'https://gateway.team.live/lpm-aggregator/api/v1/',
        STAGING         : 'https://gateway.teamstaging.live/lpm-aggregator/api/v1/',
        UAT             : 'https://gateway.teamuat.live/lpm-aggregator/api/v1/',
        BETA            : 'https://gateway.teambeta.live/lpm-aggregator/api/v1/',
        DEFAULT         : 'https://gateway.teamworkz.net/lpm-aggregator/api/v1/'
    };

    data['LPMStatsServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/lpm-stats/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/lpm-stats/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/lpm-stats/api/v1/',
        UAT             : 'https://gateway.harriuat.com/lpm-stats/api/v1/',
        BETA            : 'https://gateway.harribeta.com/lpm-stats/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/lpm-stats/api/v1/'
    };

    data['LPMIntegrationServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/lpm-integration/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/lpm-integration/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/lpm-integration/api/v1/',
        UAT             : 'https://gateway.harriuat.com/lpm-integration/api/v1/',
        BETA            : 'https://gateway.harribeta.com/lpm-integration/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/lpm-integration/api/v1/'
    };

    data['EVerifyServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/everify/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/everify/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/everify/api/v1/',
        UAT             : 'https://gateway.harriuat.com/everify/api/v1/',
        BETA            : 'https://gateway.harribeta.com/everify/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/everify/api/v1/'
    }

    data['ThoughtSpotAccessManagerServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/thoughtspot-access-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/thoughtspot-access-manager/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/thoughtspot-access-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/thoughtspot-access-manager/api/v1/',
        BETA            : 'https://gateway.harribeta.com/thoughtspot-access-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/thoughtspot-access-manager/api/v1/'
    };

    data['ThoughtSpotHost'] = {
        PRODUCTION      : 'https://harri.thoughtspot.cloud',
        INTERNAL_PROD   : 'https://harri.thoughtspot.cloud',
        STAGING         : 'https://harri.thoughtspot.cloud',
        UAT             : 'https://harri.thoughtspot.cloud',
        BETA            : 'https://harri.thoughtspot.cloud',
        DEFAULT         : 'https://harridev.thoughtspot.cloud'
    };

    data['ATRServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/atr/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/atr/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/atr/api/v1/',
        UAT             : 'https://gateway.harriuat.com/atr/api/v1/',
        BETA            : 'https://gateway.harribeta.com/atr/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/atr/api/v1/'
    };

    data['ApprovalFlowServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/approval-flow/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/approval-flow/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/approval-flow/api/v1/',
        UAT             : 'https://gateway.harriuat.com/approval-flow/api/v1/',
        BETA            : 'https://gateway.harribeta.com/approval-flow/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/approval-flow/api/v1/'
    };

    data['AdamServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/adam/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/adam/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/adam/api/v1/',
        UAT             : 'https://gateway.harriuat.com/adam/api/v1/',
        BETA            : 'https://gateway.harribeta.com/adam/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/adam/api/v1/'
    };

    data['Thoth'] = {
        PRODUCTION      : 'https://gateway.harri.com/thoth/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/thoth/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/thoth/api/v1/',
        UAT             : 'https://gateway.harriuat.com/thoth/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/thoth/api/v1/'
    };

    data['CognitoUserManager'] = {
        PRODUCTION      : 'https://gateway.harri.com/cognito-user-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/cognito-user-manager/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/cognito-user-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/cognito-user-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/cognito-user-manager/api/v1/'
    };

    data['QuestioningServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/team-questioning/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/team-questioning/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/team-questioning/api/v1/',
        UAT             : 'https://gateway.harriuat.com/team-questioning/api/v1/',
        BETA            : 'https://gateway.harribeta.com/team-questioning/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/team-questioning/api/v1/'
    };

    data['JobAuditTrailServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/job-audit-trail/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/job-audit-trail/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/job-audit-trail/api/v1/',
        UAT             : 'https://gateway.harriuat.com/job-audit-trail/api/v1/',
        BETA            : 'https://gateway.harribeta.com/job-audit-trail/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/job-audit-trail/api/v1/'
    };

    data['LMSServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/lms/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/lms/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/lms/api/v1/',
        UAT             : 'https://gateway.harriuat.com/lms/api/v1/',
        BETA            : 'https://gateway.harribeta.com/lms/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/lms/api/v1/'
    };

    data['HarriUpskillIntegration'] = {
        PRODUCTION      : 'https://gateway.harri.com/harri-upskill-integration/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/harri-upskill-integration/api/v1/',
        UAT             : 'https://gateway.harriuat.com/harri-upskill-integration/api/v1/',
        BETA            : 'https://gateway.harribeta.com/harri-upskill-integration/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/harri-upskill-integration/api/v1/'
    };

    data['NotificationCenterServersV2'] = {
        PRODUCTION      : 'https://gateway.harri.com/notification-center-v2/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/notification-center-v2/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/notification-center-v2/api/v1/',
        UAT             : 'https://gateway.harriuat.com/notification-center-v2/api/v1/',
        BETA            : 'https://gateway.harribeta.com/notification-center-v2/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/notification-center-v2/api/v1/'
    };

    data['InternalAcademy'] = {
        PRODUCTION      : 'https://gateway.harri.com/internal-academy/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/internal-academy/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/internal-academy/api/v1/',
        UAT             : 'https://gateway.harriuat.com/internal-academy/api/v1/',
        BETA            : 'https://gateway.harribeta.com/internal-academy/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/internal-academy/api/v1/'
    };

    data['SocialReferral'] = {
        PRODUCTION      : 'https://gateway.harri.com/social-referral/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/social-referral/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/social-referral/api/v1/',
        UAT             : 'https://gateway.harriuat.com/social-referral/api/v1/',
        BETA            : 'https://gateway.harribeta.com/social-referral/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/social-referral/api/v1/'
    };

    data['NotificationCenter'] = {
        PRODUCTION      : 'https://gateway.harri.com/notification-center/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/notification-center/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/notification-center/api/v1/',
        UAT             : 'https://gateway.harriuat.com/notification-center/api/v1/',
        BETA            : 'https://gateway.harribeta.com/notification-center/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/notification-center/api/v1/'
    };

    data['NotificationCenterV2'] = {
        PRODUCTION      : 'https://gateway.harri.com/notification-center-v2/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/notification-center-v2/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/notification-center-v2/api/v1/',
        UAT             : 'https://gateway.harriuat.com/notification-center-v2/api/v1/',
        BETA            : 'https://gateway.harribeta.com/notification-center-v2/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/notification-center-v2/api/v1/'
    };

    data['QuestionBankServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/question-bank/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/question-bank/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/question-bank/api/v1/',
        UAT             : 'https://gateway.harriuat.com/question-bank/api/v1/',
        BETA            : 'https://gateway.harribeta.com/question-bank/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/question-bank/api/v1/'
    };

    data['ParLaborServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/parlabor/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/parlabor/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/parlabor/api/v1/',
        UAT             : 'https://gateway.harriuat.com/parlabor/api/v1/',
        BETA            : 'https://gateway.harribeta.com/parlabor/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/parlabor/api/v1/'
    };

    data['PermissionsServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/anubis-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/anubis-manager/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/anubis-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/anubis-manager/api/v1/',
        BETA            : 'https://gateway.harribeta.com/anubis-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/anubis-manager/api/v1/'
    };

    data['AMSGatewayServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/ams/',
        INTERNAL_PROD   : 'https://gateway.harri.com/ams/',
        STAGING         : 'https://gateway.harristaging.com/ams/',
        UAT             : 'https://gateway.harriuat.com/ams/',
        BETA            : 'https://gateway.harribeta.com/ams/',
        DEFAULT         : 'https://gateway.harridev.com/ams/'
    };

    data['DataPassServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/datapass/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/datapass/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/datapass/api/v1/',
        UAT             : 'https://gateway.harriuat.com/datapass/api/v1/',
        BETA            : 'https://gateway.harribeta.com/datapass/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/datapass/api/v1/'
    };

    data['TalentAssessmentServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/assessment/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/assessment/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/assessment/api/v1/',
        UAT             : 'https://gateway.harriuat.com/assessment/api/v1/',
        BETA            : 'https://gateway.harribeta.com/assessment/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/assessment/api/v1/'
    };

    data['BackgroundCheckServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/background-check/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/background-check/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/background-check/api/v1/',
        UAT             : 'https://gateway.harriuat.com/background-check/api/v1/',
        BETA            : 'https://gateway.harribeta.com/background-check/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/background-check/api/v1/'
    };
    data['WOTCServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/wotc/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/wotc/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/wotc/api/v1/',
        UAT             : 'https://gateway.harriuat.com/wotc/api/v1/',
        BETA            : 'https://gateway.harribeta.com/wotc/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/wotc/api/v1/'
    };

    data['ChatBot'] = {
        PRODUCTION      : 'https://gateway.harri.com/carri-chat-bot/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/carri-chat-bot/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/carri-chat-bot/api/v1/',
        UAT             : 'https://gateway.harriuat.com/carri-chat-bot/api/v1/',
        BETA            : 'https://gateway.harribeta.com/carri-chat-bot/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/carri-chat-bot/api/v1/'
    };

    data['TalentPoolServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/talent-pool/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/talent-pool/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/talent-pool/api/v1/',
        UAT             : 'https://gateway.harriuat.com/talent-pool/api/v1/',
        BETA            : 'https://gateway.harribeta.com/talent-pool/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/talent-pool/api/v1/'
    };

    data['Announcements'] = {
        PRODUCTION      : 'https://gateway.harri.com/announcement/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/announcement/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/announcement/api/v1/',
        UAT             : 'https://gateway.harriuat.com/announcement/api/v1/',
        BETA            : 'https://gateway.harribeta.com/announcement/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/announcement/api/v1/'
    };

    data['tsAnnouncements'] = {
        PRODUCTION      : 'https://gateway.team.live/announcement/api/v1/',
        INTERNAL_PROD   : 'https://gateway.team.live/announcement/api/v1/',
        STAGING         : 'https://gateway.teamstaging.live/announcement/api/v1/',
        UAT             : 'https://gateway.teamuat.live/announcement/api/v1/',
        BETA            : 'https://gateway.teambeta.live/announcement/api/v1/',
        DEFAULT         : 'https://gateway.teamworkz.net/announcement/api/v1/'
    };

    data['PMS'] = {
        PRODUCTION      : 'https://gateway.harri.com/performance-management/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/performance-management/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/performance-management/api/v1/',
        UAT             : 'https://gateway.harriuat.com/performance-management/api/v1/',
        BETA            : 'https://gateway.harribeta.com/performance-management/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/performance-management/api/v1/'
    };

    data['Logbook'] = {
        PRODUCTION      : 'https://gateway.harri.com/logbook/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/logbook/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/logbook/api/v1/',
        UAT             : 'https://gateway.harriuat.com/logbook/api/v1/',
        BETA            : 'https://gateway.harribeta.com/logbook/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/logbook/api/v1/'
    };

    data['ABSServers'] = {
        PRODUCTION      : "https://gateway.harri.com/abs/api/v1/",
        INTERNAL_PROD   : "https://gateway.harri.com/abs/api/v1/",
        STAGING         : "https://gateway.harristaging.com/abs/api/v1/",
        UAT             : "https://gateway.harriuat.com/abs/api/v1/",
        BETA            : "https://gateway.harribeta.com/abs/api/v1/",
        DEFAULT         : "https://gateway.harridev.com/abs/api/v1/"
    };

    data['TimeKeepingAlertsServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/timekeeping-alert/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/timekeeping-alert/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/timekeeping-alert/api/v1/',
        UAT             : 'https://gateway.harriuat.com/timekeeping-alert/api/v1/',
        BETA            : 'https://gateway.harribeta.com/timekeeping-alert/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/timekeeping-alert/api/v1/'
    };

    data['RecognitionServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/recognition/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/recognition/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/recognition/api/v1/',
        UAT             : 'https://gateway.harriuat.com/recognition/api/v1/',
        BETA            : 'https://gateway.harribeta.com/recognition/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/recognition/api/v1/'
    };

    data['EmployeeClockStats'] = {
        PRODUCTION      : 'https://gateway.harri.com/employee-clock-stats/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/employee-clock-stats/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/employee-clock-stats/api/v1/',
        UAT             : 'https://gateway.harriuat.com/employee-clock-stats/api/v1/',
        BETA            : 'https://gateway.harribeta.com/employee-clock-stats/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/employee-clock-stats/api/v1/'
    };

    data['HumanResourceActionsServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/human-resource-actions/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/human-resource-actions/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/human-resource-actions/api/v1/',
        UAT             : 'https://gateway.harriuat.com/human-resource-actions/api/v1/',
        BETA            : 'https://gateway.harribeta.com/human-resource-actions/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/human-resource-actions/api/v1/'
    };

    data['Carri'] = {
        PRODUCTION      : 'https://gateway.harri.com/carri-rapid-response/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/carri-rapid-response/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/carri-rapid-response/api/v1/',
        UAT             : 'https://gateway.harriuat.com/carri-rapid-response/api/v1/',
        BETA            : 'https://gateway.harribeta.com/carri-rapid-response/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/carri-rapid-response/api/v1/'
    };

    data['PreHire'] = {
        PRODUCTION      : 'https://gateway.harri.com/prehire/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/prehire/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/prehire/api/v1/',
        UAT             : 'https://gateway.harriuat.com/prehire/api/v1/',
        BETA            : 'https://gateway.harribeta.com/prehire/api/v1/',
        DEFAULT         : '//gateway.harridev.com/prehire/api/v1/'
    };

    data['AccountManagement'] = {
        PRODUCTION      : 'https://gateway.harri.com/account-management/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/account-management/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/account-management/api/v1/',
        UAT             : 'https://gateway.harriuat.com/account-management/api/v1/',
        BETA            : 'https://gateway.harribeta.com/account-management/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/account-management/api/v1/'
    };

    data['CognitoUserManager'] = {
        PRODUCTION      : 'https://gateway.harri.com/cognito-user-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/cognito-user-manager/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/cognito-user-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/cognito-user-manager/api/v1/',
        BETA            : 'https://gateway.harribeta.com/cognito-user-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/cognito-user-manager/api/v1/'
    };

    data['GoodFaithEstimatesServers'] = {
        PRODUCTION      : 'https://gateway.harri.com/good-faith-estimate/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/good-faith-estimate/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/good-faith-estimate/api/v1/',
        UAT             : 'https://gateway.harriuat.com/good-faith-estimate/api/v1/',
        BETA            : 'https://gateway.harribeta.com/good-faith-estimate/api/v1/',
        DEFAULT         : '//gateway.harridev.com/good-faith-estimate/api/v1/'
    };

    data['EmployeeNotes'] = {
        PRODUCTION      : 'https://gateway.harri.com/employee-notes/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/employee-notes/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/employee-notes/api/v1/',
        UAT             : 'https://gateway.harriuat.com/employee-notes/api/v1/',
        BETA            : 'https://gateway.harribeta.com/employee-notes/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/employee-notes/api/v1/',
    };

    data['CorHrCustomFields'] = {
        PRODUCTION      : 'https://gateway.harri.com/core-hr-employee-custom-fields/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/core-hr-employee-custom-fields/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/core-hr-employee-custom-fields/api/v1/',
        UAT             : 'https://gateway.harriuat.com/core-hr-employee-custom-fields/api/v1/',
        BETA            : 'https://gateway.harribeta.com/core-hr-employee-custom-fields/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/core-hr-employee-custom-fields/api/v1/',
    };

    data['TeamLiveShiftOfferFinancials'] = {
        PRODUCTION      : 'https://gateway.harri.com/team-live-shift-offer-financials/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/team-live-shift-offer-financials/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/team-live-shift-offer-financials/api/v1/',
        UAT             : 'https://gateway.harriuat.com/team-live-shift-offer-financials/api/v1/',
        BETA            : 'https://gateway.harribeta.com/team-live-shift-offer-financials/api/v1/',
        DEFAULT         : '//gateway.harridev.com/team-live-shift-offer-financials/api/v1/'
    };

    data['UserTrackingManagerServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/user-tracking-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/user-tracking-manager/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/user-tracking-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/user-tracking-manager/api/v1/',
        BETA            : 'https://gateway.harribeta.com/user-tracking-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/user-tracking-manager/api/v1/'
    };

    data['UserPreferencesManagerServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/user-preferences-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/user-preferences-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/user-preferences-manager/api/v1/',
        BETA            : 'https://gateway.harribeta.com/user-preferences-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/user-preferences-manager/api/v1/'
    };

    data['CoreHRPositionHierarchyServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/core-hr-position-hierarchy/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/core-hr-position-hierarchy/api/v1/',
        UAT             : 'https://gateway.harriuat.com/core-hr-position-hierarchy/api/v1/',
        BETA            : 'https://gateway.harribeta.com/core-hr-position-hierarchy/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/core-hr-position-hierarchy/api/v1/'
    };

    data['CameraTagApp'] = {
        PRODUCTION      : 'a-68919c70-3431-0132-cee9-12313914f10b',
        INTERNAL_PROD   : 'a-68919c70-3431-0132-cee9-12313914f10b',
        BETA            : 'a-1e2c92b0-c7e5-013a-687f-0aac5b511429',
        UAT             : 'a-d59340c0-3cac-0139-a351-0aac5b511429',
        DEFAULT         : 'a-643df900-847c-0132-10a8-22000a8c0328'
    };

    data['CameraTagQuestionBankApp'] = {
        PRODUCTION      : 'a-cd9f01b0-82f2-0137-5fb9-0adeb7a592e0',
        INTERNAL_PROD   : 'a-cd9f01b0-82f2-0137-5fb9-0adeb7a592e0',
        UAT             : 'a-bc8916c0-3cac-0139-a352-0aac5b511429',
        BETA            : 'a-7233fe10-c7e5-013a-687f-0aac5b511429',
        DEFAULT         : 'a-dc1b0330-7a57-0137-4e07-02f6e3696dde'
    };

    data['SegmentKey'] = {
        PRODUCTION      : '8elno4cfk4',
        INTERNAL_PROD   : '8elno4cfk4',
        BETA            : '5gcv7zaU0rUaTRA7A44pa4SOGwNq7MnT',
        DEMO            : '0FjN4jTD7KUnKPcFDMXQgXpOqEGcIeiY',
        UAT             : '07PlBxDYLnpswRV5ZIOCCrUioszuj6Ik',
        DEFAULT         : 'MGhuwSDIdMYMPPk04wnqlnbDYGGqkVgX'
    };

    data['GoogleServiceKey'] = {
        PRODUCTION      : 'AIzaSyCHLDsUWX58Q-ptqs9UqHGG3qfzY8YE2j8',
        INTERNAL_PROD   : 'AIzaSyCHLDsUWX58Q-ptqs9UqHGG3qfzY8YE2j8',
        BETA            : 'AIzaSyAZ9TCCEM1HuTvXuyT3fuWjCGpvt9HC4yw',
        UAT             : 'AIzaSyCVIrr-BLS8q1AFnJHrkwf4WXdIKC9Nmx8',
        DEFAULT         : 'AIzaSyCDb6766ei_tc6ZOrhodn9kO8vKHT2dmvk'
    };

    data['StripeKey'] = {
        PRODUCTION      : 'pk_live_MjNdZDMBqforbHxc5SvbD2XJ',
        INTERNAL_PROD   : 'pk_live_MjNdZDMBqforbHxc5SvbD2XJ',
        DEFAULT         : 'pk_test_3eNmyC5bcJBSOOm3GkQtJIM5'
    };

    data['TranslationLookup'] = {
        PRODUCTION      : 'https://media-cdn.harri.com/language/',
        INTERNAL_PROD   : 'https://media-cdn.harri.com/language/',
        STAGING         : 'https://media-cdn.harriuat.com/language/',
        UAT             : 'https://media-cdn.harriuat.com/language/',
        DEFAULT         : 'https://media-cdn.harridev.com/language/'
    };

    data['AnalyticsEnabled'] = {
        DEFAULT         : true
    };

    data['cookieStoreDomain'] = {
        PRODUCTION      : ".harri.com",
        INTERNAL_PROD   : ".harri.com",
        UAT             : ".harriuat.com",
        BETA            : ".harribeta.com",
        DEFAULT         : ".harridev.com"
    };

    data['TLCookieStoreDomain'] = {
        PRODUCTION      : ".team.live",
        INTERNAL_PROD   : ".team.live",
        UAT             : ".teamuat.live",
        BETA            : ".teambeta.live",
        DEFAULT         : ".teamworkz.net"
    };

    data['MobilePromotion'] = {
        DEMO            : false,
        DEFAULT         : true
    };

    data['DebugEnabled'] = {
        PRODUCTION      : false,
        INTERNAL_PROD   : false,
        DEMO            : false,
        DEFAULT         : true
    };

    data['BotsEnabled'] = {
        PRODUCTION      : true,
        DEFAULT         : false
    };

    data['GoogleLanguageDetectionEnabled'] = {
        PRODUCTION      : true,
        INTERNAL_PROD   : true,
        DEFAULT         : false
    };

    data['FacebookAppId'] = {
        PRODUCTION      : "1448937138662995",
        INTERNAL_PROD   : "1448937138662995",
        DEFAULT         : "297220054078708"
    };

    data['FacebookPixelId'] = {
        PRODUCTION      : "285888225085807",
        INTERNAL_PROD   : "285888225085807",
        DEFAULT         : "285888225085807"
    };

    data['GoogleRecaptchaSiteKey'] = {
        PRODUCTION      : "6LfHpDMqAAAAAGk59S49qxLCu4FgR-MYNXxPx83l",
        INTERNAL_PROD   : "6LfHpDMqAAAAAGk59S49qxLCu4FgR-MYNXxPx83l",
        STAGING         : "6LfHpDMqAAAAAGk59S49qxLCu4FgR-MYNXxPx83l",
        UAT             : "6Lf2ZzQqAAAAAD-ehqEJzmZWl0-0HCAhP5lD71Bd",
        BETA            : "6LcFojQqAAAAAKYsUThPbhpea-quyMChfIqYZZUp",
        DEFAULT         : "6LeCqjMqAAAAANKL9ivaQ35sXY1SEVLKk7pWNIv3"
    };

    data['GoogleClientID'] = {
        PRODUCTION      : "636179390157-g5ikvmk091ub0i994fmn5eme6rqsndm7.apps.googleusercontent.com",
        INTERNAL_PROD   : "636179390157-g5ikvmk091ub0i994fmn5eme6rqsndm7.apps.googleusercontent.com",
        STAGING         : "344444086265-lsrq1i06jvlfii6mdked1uj9n4g6fj0v.apps.googleusercontent.com",
        UAT             : "344444086265-lsrq1i06jvlfii6mdked1uj9n4g6fj0v.apps.googleusercontent.com",
        BETA            : "905999141571-n2u3cdbnqhvbmmadchg6hj1fg4rlmmsh.apps.googleusercontent.com",
        DEFAULT         : "636179390157-ev1amkldpmeqchcefts72obi4152qi9n.apps.googleusercontent.com"
    };

    data['checkrClientId'] = {
        PRODUCTION      : "8fb3570ea8153cceff4ed2c2",
        INTERNAL_PROD   : "8fb3570ea8153cceff4ed2c2",
        DEFAULT         : "5be66de2ecd845e73d89dbf5"
    };

    data['checkrDomain'] = {
        PRODUCTION      : "checkr.com",
        INTERNAL_PROD   : "checkr.com",
        DEFAULT         : "checkrhq-staging.net"
    };

    data['GiphyServer'] = {
        DEFAULT         : 'https://api.giphy.com/v1/',
    };

    data['GiphyAPIKey'] = {
        DEFAULT         : 'ahFXNyQvTN0THs6SaBW15JDNNNIsKlo1',
    };

    data['TsGiphyAPIKey'] = {
        DEFAULT         : '6rAcODkFMuwPlGsHoFlBTkqBzaTqHxu2',
    };

    data['TeamLiveReports'] = {
        PRODUCTION      : 'https://gateway.harri.com/reporting-generator/',
        INTERNAL_PROD   : 'https://gateway.harri.com/reporting-generator/',
        STAGING         : 'https://gateway.harristaging.com/reporting-generator/',
        UAT             : 'https://gateway.harriuat.com/reporting-generator/',
        BETA            : 'https://gateway.harribeta.com/reporting-generator/',
        DEFAULT         : 'https://gateway.harridev.com/reporting-generator/'
    };

    data['ProfileMatching'] = {
        PRODUCTION      : 'https://gateway.harri.com/profile-matching-api/api/',
        INTERNAL_PROD   : 'https://gateway.harri.com/profile-matching-api/api/',
        UAT             : 'https://gateway.harriuat.com/profile-matching-api/api/',
        BETA             : 'https://gateway.harribeta.com/profile-matching-api/api/',
        DEFAULT         : 'https://gateway.harridev.com/profile-matching-api/api/'
    };

    data['CorHrNotificationManagerServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/core-hr-notification-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/core-hr-notification-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/core-hr-notification-manager/api/v1/',
        BETA            : 'https://gateway.harribeta.com/core-hr-notification-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/core-hr-notification-manager/api/v1/'
    };

    data['DashboardsManagement'] = {
        PRODUCTION      : 'https://gateway.harri.com/reporting-management/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/reporting-management/v1/',
        STAGING         : 'https://gateway.harristaging.com/reporting-management/v1/',
        UAT             : 'https://gateway.harriuat.com/reporting-management/v1/',
        BETA            : 'https://gateway.harribeta.com/reporting-management/v1/',
        DEFAULT         : 'https://gateway.harridev.com/reporting-management/v1/'
    };

    data['VersionManagerServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/frontend-version-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/frontend-version-manager/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/frontend-version-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/frontend-version-manager/api/v1/',
        BETA            : 'https://gateway.harribeta.com/frontend-version-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/frontend-version-manager/api/v1/'
    };

    data['SettingsAudit'] = {
        PRODUCTION      : 'https://gateway.harri.com/team-live-settings-audit/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/team-live-settings-audit/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/team-live-settings-audit/api/v1/',
        UAT             : 'https://gateway.harriuat.com/team-live-settings-audit/api/v1/',
        BETA            : 'https://gateway.harribeta.com/team-live-settings-audit/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/team-live-settings-audit/api/v1/'
    };

    data['UsersSecondaryAuthServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/',
        INTERNAL_PROD   : 'https://gateway.harri.com/',
        STAGING         : 'https://gateway.harristaging.com/',
        UAT             : 'https://gateway.harriuat.com/',
        BETA            : 'https://gateway.harribeta.com/',
        DEFAULT         : 'https://gateway.harridev.com/'
    };

    data['SpecialEvents'] = {
        PRODUCTION      : 'https://gateway.harri.com/brand-special-event/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/brand-special-event/api/v1/',
        UAT             : 'https://gateway.harriuat.com/brand-special-event/api/v1/',
        BETA            : 'https://gateway.harribeta.com/brand-special-event/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/brand-special-event/api/v1/'
    };

    data['HarriEngageServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/harri-engage/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/harri-engage/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/harri-engage/api/v1/',
        UAT             : 'https://gateway.harriuat.com/harri-engage/api/v1/',
        BETA            : 'https://gateway.harribeta.com/harri-engage/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/harri-engage/api/v1/'
    };

    data['OnBoardingJourneyServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/on-boarding-journey/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/on-boarding-journey/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/on-boarding-journey/api/v1/',
        UAT             : 'https://gateway.harriuat.com/on-boarding-journey/api/v1/',
        BETA            : 'https://gateway.harribeta.com/on-boarding-journey/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/on-boarding-journey/api/v1/'
    };

    data['SubwayServer'] = {
        PRODUCTION      : 'https://gateway.harri.com/subway-brand-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/subway-brand-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/subway-brand-manager/api/v1/',
        BETA            : 'https://gateway.harribeta.com/subway-brand-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/subway-brand-manager/api/v1/'
    };

    data['ExternalTipProvider'] = {
        PRODUCTION      : 'https://gateway.harri.com/external-tip-provider/api/v1/',
        INTERNAL_PROD   : 'httpri.jss://gateway.harri.com/external-tip-provider/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/external-tip-provider/api/v1/',
        UAT             : 'https://gateway.harriuat.com/external-tip-provider/api/v1/',
        BETA            : 'https://gateway.harribeta.com/external-tip-provider/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/external-tip-provider/api/v1/'
    };

    data['WorkRestriction'] = {
        PRODUCTION      : 'https://gateway.harri.com/employee-work-restriction/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/employee-work-restriction/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/employee-work-restriction/api/v1/',
        UAT             : 'https://gateway.harriuat.com/employee-work-restriction/api/v1/',
        BETA            : 'https://gateway.harribeta.com/employee-work-restriction/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/employee-work-restriction/api/v1/'
    };

    data['WorkflowAutomationManager'] = {
        PRODUCTION      : 'https://gateway.harri.com/workflow-automation-manager/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/workflow-automation-manager/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/workflow-automation-manager/api/v1/',
        UAT             : 'https://gateway.harriuat.com/workflow-automation-manager/api/v1/',
        BETA            : 'https://gateway.harribeta.com/workflow-automation-manager/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/workflow-automation-manager/api/v1/'
    };

    data['GenAiAgent'] = {
        PRODUCTION      : 'https://gateway.harri.com/harri-gen-ai-agent/api/v1/',
        INTERNAL_PROD   : 'https://gateway.harri.com/harri-gen-ai-agent/api/v1/',
        STAGING         : 'https://gateway.harristaging.com/harri-gen-ai-agent/api/v1/',
        UAT             : 'https://gateway.harriuat.com/harri-gen-ai-agent/api/v1/',
        BETA            : 'https://gateway.harribeta.com/harri-gen-ai-agent/api/v1/',
        DEFAULT         : 'https://gateway.harridev.com/harri-gen-ai-agent/api/v1/'
    };

    data['ExtGenAiAgent'] = {
        PRODUCTION      : 'https://ext-gateway.harri.com/harri-gen-ai-agent/api/v1/',
        INTERNAL_PROD   : 'https://ext-gateway.harri.com/harri-gen-ai-agent/api/v1/',
        STAGING         : 'https://ext-gateway.harristaging.com/harri-gen-ai-agent/api/v1/',
        UAT             : 'https://ext-gateway.harriuat.com/harri-gen-ai-agent/api/v1/',
        BETA            : 'https://ext-gateway.harribeta.com/harri-gen-ai-agent/api/v1/',
        DEFAULT         : 'https://ext-gateway.harridev.com/harri-gen-ai-agent/api/v1/'
    };

    data['DataDogConfig'] = {
        DEFAULT: {
            "applicationId": "13339ba2-2cc7-4d75-a976-67c8f7e587f0",
            "clientToken": "pubd0494b9a8be1ebb0d61b23ea51fdb6b3",
        },
    };

    data['IpcPortalConfig'] = {
        DEFAULT: 'https://harri--partialsb.sandbox.my.site.com/FranchiseeSignUpPortal',
        INTERNAL_PROD: 'https://harri.my.site.com/FranchiseeSignUpPortal',
        PRODUCTION: 'https://harri.my.site.com/FranchiseeSignUpPortal'
    };

    data['IpcSubwayDashboardConfig'] = {
        DEFAULT: 'https://go.harri.com/ipc-subway-staging',
        DEV: 'https://go.harri.com/ipc-subway-staging',
        STAGING: 'https://go.harri.com/ipc-subway-staging',
        INTERNAL_PROD: 'https://go.harri.com/get-ready-to-launch?hs_preview=CsWteuvs-101843526472',
        PRODUCTION: 'https://go.harri.com/get-ready-to-launch?hs_preview=CsWteuvs-101843526472',
    };

    data['IFrameLoginConfig'] = {
        DEFAULT: {
            "userPoolId": "us-east-1_mk6a5pNIL",
            "userPoolWebClientId": "ae15r3krf43t1jmcqebtgf636",
            "userPoolWebClientDomain": "oauth.harridev.com",
        },
        STAGING: {
            "userPoolId": "us-east-1_lYXGVyvUl",
            "userPoolWebClientId": "6hvg0o3ht23isvn67giahhbgee",
            "userPoolWebClientDomain": "oauth.harristaging.com",
        },
        UAT: {
            "userPoolId": "us-east-1_lYXGVyvUl",
            "userPoolWebClientId": "6hvg0o3ht23isvn67giahhbgee",
            "userPoolWebClientDomain": "oauth.harristaging.com",
        },
        BETA: {
            "userPoolId": "us-east-1_YAhTEI6Hr",
            "userPoolWebClientId": "39bcg3usbfqdms1a3vvod83t8l",
            "userPoolWebClientDomain": "oauth.harribeta.com",
        },
        INTERNAL_PROD: {
            "userPoolId": "us-east-1_Ggpbqc92e",
            "userPoolWebClientId": "7rbq1fkugjphupo0ujb1qetuar",
            "userPoolWebClientDomain": "oauth.harri.com",
        },
        PRODUCTION: {
            "userPoolId": "us-east-1_Ggpbqc92e",
            "userPoolWebClientId": "7rbq1fkugjphupo0ujb1qetuar",
            "userPoolWebClientDomain": "oauth.harri.com",
        }
    };

    data['LiveScheduleIFrameLoginConfig'] = {
        DEFAULT: {
            "userPoolId": "us-east-1_mk6a5pNIL",
            "userPoolWebClientId": "mha7mujkm4qrkm3o7l8h0ij4q",
            "userPoolWebClientDomain": "oauth.harridev.com",
        },
        STAGING: {
            "userPoolId": "us-east-1_lYXGVyvUl",
            "userPoolWebClientId": "mddb4n6metl7vsaj6c4latcd7",
            "userPoolWebClientDomain": "oauth.harristaging.com",
        },
        UAT: {
            "userPoolId": "us-east-1_lYXGVyvUl",
            "userPoolWebClientId": "mddb4n6metl7vsaj6c4latcd7",
            "userPoolWebClientDomain": "oauth.harristaging.com",
        },
        INTERNAL_PROD: {
            "userPoolId": "us-east-1_Ggpbqc92e",
            "userPoolWebClientId": "1s8n1umsgnom6e5v7kkdu7u872",
            "userPoolWebClientDomain": "oauth.harri.com",
        },
        PRODUCTION: {
            "userPoolId": "us-east-1_Ggpbqc92e",
            "userPoolWebClientId": "1s8n1umsgnom6e5v7kkdu7u872",
            "userPoolWebClientDomain": "oauth.harri.com",
        }
    };

    data['EmployeeAppPusherConfig'] = {
        DEFAULT: {
            "KEY": "95f5a8aa55ced23e03f3",
            "CLUSTER": "mt1",
        },
        STAGING: {
            "KEY": "e8dca4e93a4059b7b085",
            "CLUSTER": "mt1",
        },
        UAT: {
            "KEY": "e8dca4e93a4059b7b085",
            "CLUSTER": "mt1",
        },
        BETA: {
            "KEY": "6d06dba8fa847f02ec13",
            "CLUSTER": "mt1",
        },
        PRODUCTION: {
            "KEY": "365833de15aaecae0e8b",
            "CLUSTER": "mt1",
        }
    };

    data['CommsHubAppPusherConfig'] = {
        DEFAULT: {
            "KEY": "e4f939d30310166c377c",
            "CLUSTER": "mt1",
        },
        STAGING: {
            "KEY": "ab7b9565f0be5b3d14ea",
            "CLUSTER": "mt1",
        },
        UAT: {
            "KEY": "ab7b9565f0be5b3d14ea",
            "CLUSTER": "mt1",
        },
        BETA: {
            "KEY": "8abcdf2ac08b625f3149",
            "CLUSTER": "mt1",
        },
        INTERNAL_PROD: {
            "KEY": "d660e443fd539dc3fe65",
            "CLUSTER": "mt1",
        },
        PRODUCTION: {
            "KEY": "d660e443fd539dc3fe65",
            "CLUSTER": "mt1",
        }
    };

    data['ForethoughtAPIKey'] = {
        DEFAULT         : '9b7c0c18-5b2f-485f-a78d-2a3a51d8b352'
    };

    data['oAuthEnabled'] = {
        PRODUCTION      : true,
        DEV             : true,
        STAGING         : true,
        UAT             : true,
        BETA            : true,
        DEFAULT         : true
    };

    data['indeedClientId'] = {
        PRODUCTION      : "db230e6f7be4ebfe6ec0b3b29ca4521492e3b2229f6b57aa9269691892438b33",
        INTERNAL_PROD   : "db230e6f7be4ebfe6ec0b3b29ca4521492e3b2229f6b57aa9269691892438b33",
        DEFAULT         : "99a6cf0940c56f2e9542f06f5a3b757767267cd425300f883e0a3337743202a0"
    };

    /**
     * Read configuration based on environment
     * @param key, name of configuration to read
     */
    self.get = function(key) {
        if (!data[key]) {
            throw(key + ' is not defind in environments.config.js');
        }

        var environment = currentEnvironment || getEnvironment();

        if (environment.env) {
            currentEnvironment = environment;
            var result = typeof(data[key][environment.env]) != 'undefined'? data[key][environment.env]: data[key][self.DEFAULT];
            return prependProtocal(result);
        }
        else {
            throw("Couldn't read environment in environment.config.js");
        }
    };

    /**
     * Return current environment information (might return null in Node.js side)
     */
    self.getEnv = function() {
        return getEnvironment();
    };

    /**
     * Get clean domain name given a hostname e.g. www.harri.com will return harri.com
     */
    var stripDomainName = function(hostname) {

        if (hostname.indexOf('www.') === 0) {
            return hostname.substring(4);
        }

        if (
            hostname.indexOf('es.') === 0 ||
            hostname.indexOf('fr.') === 0 ||
            hostname.indexOf('de.') === 0 ||
            hostname.indexOf('ru.') === 0 ||
            hostname.indexOf('ar.') === 0 ||
            hostname.indexOf('pl.') === 0 ||
            hostname.indexOf('tr.') === 0
        ) {
            return hostname.substring(3);
        }

        return hostname;
    };

    /**
     * Get Domain based on window.location or global.host (Node.js side)
     */
    var getDomain = function() {
        var domain;

        try {
            domain = stripDomainName(window.location.hostname);
        }
        catch (e) {
            var host = global.host && global.host.split(":")[0];
            domain = stripDomainName(host);
        }

        return domain;
    };

    self.getFullBaseURL = function() {
        var domain = 'https://' + getDomain();
        var port = window.location.port && window.location.port !== "443" ? ':'+window.location.port:'';
        return domain + port;
    };

    self.getMainDomain = function() {
        var domainParts = getDomain().split('.')
        var domain = ['https://', domainParts[domainParts.length - 2], '.', domainParts[domainParts.length - 1]].join('');
        return domain;
    };

    /**
     * Get environment constant based on window.location or global.host in Node.js side
     */
    var getEnvironment = function() {
        var domain = getDomain();
        var environment = {};

        if (domain.indexOf(HOSTS.TEAM_SCHEDULE) > -1 || domain.indexOf(HOSTS.TEAM_SCHEDULE_DEV) > -1
            || domain.indexOf(HOSTS.TEAM_SCHEDULE_STAGING) > -1 || domain.indexOf(HOSTS.TEAM_SCHEDULE_UAT) > -1
            || domain.indexOf(HOSTS.TEAM_SCHEDULE_BETA) > -1) {
            environment.host = self.TEAM_SCHEDULE;
        }
        else if (domain.indexOf(HOSTS.HARRI) > -1) {
            environment.host = self.HARRI;
        }
        else if (domain.indexOf(HOSTS.HARRI_DEV) > -1) {
            environment.host = self.HARRI_DEV;
        }
        else if (domain.indexOf(HOSTS.HARRI_UAT) > -1) {
            environment.host = self.HARRI_UAT;
        }
        else if (domain.indexOf(HOSTS.HARRI_BETA) > -1) {
            environment.host = self.HARRI_BETA;
        }

        // If domain is exactly the host name that we have, this is production
        if (domain == HOSTS.HARRI || domain == HOSTS.TEAM_SCHEDULE) {
            environment.env = self.PRODUCTION;
        }
        else if(domain === HOSTS.INTERNAL_PROD || domain === HOSTS.INTERNAL_TEMP_PROD){
            environment.env = self.INTERNAL_PROD;
        }
        else if (domain == HOSTS.HARRI_DEV || domain == HOSTS.TEAM_SCHEDULE_DEV) {
            environment.env = self.DEV;
        }
        else if (domain == HOSTS.HARRI_UAT || domain == HOSTS.TEAM_SCHEDULE_UAT) {
            environment.env = self.UAT;
        }
        else if (domain == HOSTS.HARRI_BETA || domain == HOSTS.TEAM_SCHEDULE_BETA) {
            environment.env = self.BETA;
        }
        else {
            // Get The prefix from the hostanme e.g. dev, ...
            var prefix = domain.replace(HOSTS.HARRI, "").replace(HOSTS.HARRI_UAT, "").replace(HOSTS.TEAM_SCHEDULE, "");

            switch (prefix) {
                case 'dev.':
                    environment.env = self.DEV;
                    break;
                case 'demo.':
                    environment.env = self.DEMO;
                    break;
                case 'st1.':
                case 'st2.':
                case 'st3.':
                    if (domain.indexOf(HOSTS.HARRI_UAT) > -1) {
                        environment.env = self.UAT;
                    } else {
                        environment.env = self.STAGING;
                    }
                    break;
                default:
                    environment.env = self.DEFAULT;
            }
        }

        return environment;
    };

    /**
     * Add the right protocal (based on page URL or request protocal)
     */
    var prependProtocal = function (domain) {
        var fullDomain;

        // Check if protocal is needed, fail in case of undefined
        if (!domain.indexOf || domain.indexOf('//') != 0) {
            return domain;
        }

        try {
            fullDomain = window.location.protocol + domain;
        }
        catch (e) {
            // Node.js side
            fullDomain = global.protocol + domain;
        }

        return fullDomain;
    }

    self.getTeamLiveOrigin = function () {
        var origin = window.location.origin;
        var domain = getDomain();
        if (domain.indexOf(HOSTS.HARRI) > -1) {
            return origin.replace(HOSTS.HARRI, HOSTS.TEAM_SCHEDULE);
        }
        else if (domain.indexOf(HOSTS.HARRI_DEV) > -1) {
            return origin.replace(HOSTS.HARRI_DEV, HOSTS.TEAM_SCHEDULE_DEV);
        }
        else if (domain.indexOf(HOSTS.HARRI_UAT) > -1) {
            return origin.replace(HOSTS.HARRI_UAT, HOSTS.TEAM_SCHEDULE_UAT);
        }
        else if (domain.indexOf(HOSTS.HARRI_BETA) > -1) {
            return origin.replace(HOSTS.HARRI_BETA, HOSTS.TEAM_SCHEDULE_BETA);
        }
    }
};

if (typeof window !== "undefined") {
    window.EnvironmentsConfig = EnvironmentsConfig;
}

//export public configuration to node.js app.
try {
    module.exports = EnvironmentsConfig;
} catch (e) { }
